import React, { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import ToolProvider from '../index'
import ThingDialog from '../../Things/ThingDialog'
import TearSheetDialog from '../../TearSheetDialog'
import TransactionsPopUp from '../../Transactions/TransactionsPopUp'

export function AllToolProvider (
  {
    children,
    includeThingDialog = true,
    includeTearSheet = true,
    includeTransactions = true
  }) {
  const thingDialogRef = useRef(null)
  const tearSheetDialogRef = useRef(null)
  const thingDialogTool = useMemo(() => ({
    open: (config) => thingDialogRef.current.open(config)
  }), [])
  const tearSheetDialogTool = useMemo(() => ({
    open: (config) => tearSheetDialogRef.current?.open(config)
  }), [])

  let content = children

  if (includeTransactions) {
    content = <TransactionsPopUp>{content}</TransactionsPopUp>
  }

  if (includeTearSheet) {
    content = (
      <ToolProvider name='tearSheetDialog' tool={tearSheetDialogTool}>
        {content}
        <TearSheetDialog ref={tearSheetDialogRef} />
      </ToolProvider>
    )
  }

  if (includeThingDialog) {
    content = (
      <ToolProvider name='thingDialog' tool={thingDialogTool}>
        {content}
        <ThingDialog ref={thingDialogRef} />
      </ToolProvider>
    )
  }

  return content
}

AllToolProvider.propTypes = {
  children: PropTypes.node,
  includeThingDialog: PropTypes.bool,
  includeTearSheet: PropTypes.bool,
  includeTransactions: PropTypes.bool
}

export default AllToolProvider
